// extracted by mini-css-extract-plugin
module.exports = {"back-button":"BackButton_back-button__38euu","white":"BackButton_white__21vHV"};